import Scrollactive from "./scrollactive.vue";
import { Plugin, App } from "vue";

declare global {
  interface Window {
    Vue: App;
  }
}

const Plugin: Plugin = {
  install: (Vue: App<any>) => {
    if ((Plugin.install as any).installed) return;

    Vue.component("scrollactive", Scrollactive);
  }
};

if (typeof window !== "undefined" && window.Vue) {
  Plugin.install(window.Vue);
}

export default Plugin;
